// extracted by mini-css-extract-plugin
export default {"container":"SupplierReplacementSelect_container__rMpzr","header":"SupplierReplacementSelect_header__1qySq","buttonWrapper":"SupplierReplacementSelect_buttonWrapper__Ivuf4"};